import { render, staticRenderFns } from "./storeNumDetail.vue?vue&type=template&id=b5c539dc&"
import script from "./storeNumDetail.vue?vue&type=script&lang=js&"
export * from "./storeNumDetail.vue?vue&type=script&lang=js&"
import style0 from "./storeNumDetail.vue?vue&type=style&index=0&id=b5c539dc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports